<template>
  <div class="content-wrapper" :class="{ 'loading-opacity': preloader }">
    <app-overlay-loader v-if="preloader" />
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Ajuste"
          directory="Documentación"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            Regresar
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label pt-0 my-3">
        <h5>{{inputs?.accreditation_type?.name}} - {{inputs?.accreditation_activity?.name}}</h5>
      </legend>
    </div>
    
    <div class="accordion" id="accordionExample">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Solicitud {{inputs.record ? `(${inputs.record})` : ""}}
            </button>
          </h5>
        </div>

        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div class="card-body">
            <h5 class="my-2 text-primary"> Documentación </h5>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col" class="align-middle">Documento</th>
                  <th scope="col" class="align-middle">Nombre</th>
                  <th scope="col" class="align-middle">Fecha</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 10%"
                  ></th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 10%"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Solicitud firmada</td>
                  <td><small class="text-primary">{{
                      inputs.request_signed ? `${inputs?.request_signed?.path.split("/")[inputs?.request_signed?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ inputs?.request_signed?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(inputs, 'request_signed')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Solicitud firmada','request_signed', inputs.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
      <div class="card" v-for="(value, key) in evaltest" :key="key">
        <div class="card-header" id="headingevalt">
          <h5 class="mb-0">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="`#collapse${key}`" aria-expanded="true" aria-controls="collapseOne">
              {{value.type === 'E' ? 'Evaluación' : 'Testifación'}} {{value.code ? `(${value.code})` : ""}}
            </button>
          </h5>
        </div>
        <div :id="`collapse${key}`" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
          <div class="card-body">
            <h5 class="my-2 text-primary"> Documentación </h5>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col" class="align-middle">Documento</th>
                  <th scope="col" class="align-middle">Nombre</th>
                  <th scope="col" class="align-middle">Fecha</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 10%"
                  ></th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 10%"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Propuesta de designación de equipo evaluador</td>
                  <td><small class="text-primary">{{
                      value.evaluation_team_file ? `${value?.evaluation_team_file?.path.split("/")[value?.evaluation_team_file?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.evaluation_team_file?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'evaluation_team_file')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Propuesta de designación de equipo evaluador','evaluation_team_file', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Plan de muestreo</td>
                  <td><small class="text-primary">{{
                      value.sampling_plan_file ? `${value?.sampling_plan_file?.path.split("/")[value?.sampling_plan_file?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.sampling_plan_file?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'sampling_plan_file')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Plan de muestreo','sampling_plan_file', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Matriz de riesgos</td>
                  <td><small class="text-primary">{{
                      value.risk_matrix ? `${value?.risk_matrix?.path.split("/")[value?.risk_matrix?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.risk_matrix?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'risk_matrix')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Matriz de riesgos','risk_matrix', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Proforma</td>
                  <td><small class="text-primary">{{
                      value.proforma ? `${value?.proforma?.path.split("/")[value?.proforma?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.proforma?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'proforma')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Proforma','proforma', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Borrador del plan de evaluación</td>
                  <td><small class="text-primary">{{
                      value.standard_evaluate ? `${value?.standard_evaluate?.path.split("/")[value?.standard_evaluate?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.standard_evaluate?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'standard_evaluate')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Borrador del plan de evaluación','standard_evaluate', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Informe de evaluación documental</td>
                  <td><small class="text-primary">{{
                      value.report_documentary_evaluation ? `${value?.report_documentary_evaluation?.path.split("/")[value?.report_documentary_evaluation?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.report_documentary_evaluation?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'report_documentary_evaluation')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Informe de evaluación documental','report_documentary_evaluation', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Plan de evaluación InSitu</td>
                  <td><small class="text-primary">{{
                      value.evaluation_plan_report ? `${value?.evaluation_plan_report?.path.split("/")[value?.evaluation_plan_report?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.evaluation_plan_report?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'evaluation_plan_report')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Plan de evaluación','evaluation_plan_report', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Informe de evaluación In-Situ Remota</td>
                  <td><small class="text-primary">{{
                      value.remote_in_situ_assessment_report ? `${value?.remote_in_situ_assessment_report?.path.split("/")[value?.remote_in_situ_assessment_report?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.remote_in_situ_assessment_report?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'remote_in_situ_assessment_report')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Informe de evaluación In-Situ Remota','remote_in_situ_assessment_report', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Matriz de Análisis de riesgos y programa</td>
                  <td><small class="text-primary">{{
                      value.risk_matrix505 ? `${value?.risk_matrix505?.path.split("/")[value?.risk_matrix505?.path.split("/").length - 1]}` : ""
                    }}</small></td>
                  <td>{{ value?.risk_matrix505?.created_at | dateFormat }}</td>
                  <td>
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value, 'risk_matrix505')"
                    >
                      <app-icon name="file" />
                      <br/>
                      {{ $t("view") }}
                    </button>
                  </td>
                  <td><button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openModalActive('Matriz de Análisis de riesgos y programa','risk_matrix505', value.id)"
                    >
                      <app-icon name="edit" />
                      <br/>
                      {{ $t("edit") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>

    <setting-documents-modal
      v-if="isEditModalActive"
      :table-id="tableId"
      :filename="filename"
      :filetype="filetype"
      :acc-app="inputs"
      :data-id="dataId"
      @close-modal="closeModalActive"
    />

  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
    extends: CoreLibrary,
    mixins: [FormMixin],
    props: {
    accAppId: String,
    },
    data() {
        return {
            preloader: false,
            isEditModalActive: false,
            codeactivity: "",
            tableId: "setting-documents-tab",
            inputs: {},
            evaltest: {},
            rowData: {},
            filename: "",
            filetype: "",
            dataId: "",
        };
    },
    filters: {
    dateFormat: function (value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD HH:mm");
      } else {
        return "";
      }
    },
  },
    created() {
        this.data();
    },
    methods: {
        returnPage() {
            window.location.href = `/accreditationtechnical/setting-information/documents`;
        },
        data() {
            this.preloader = true;
            axiosGet(
                `/accreditationtechnical/setting-information/documents/show/${this.accAppId}`
            )
            .then((response) => {
            if (response.status == 200) {
                this.inputs = response.data ? response.data.accApp : {};
                this.evaltest = response.data ? response.data.evalTes : {};
                this.codeactivity = response.data.accApp.accreditation_activity.code;
                
            }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.preloader = false;
            });
        },

        openTab(obj, fileName) {
          if (obj[fileName]) {
            const w = window.open(obj[fileName].path, "_blank");
            w.focus();
          } else {
            this.$toastr.e("No hay documento disponible.");
          }
        },

        reSetData() {
          this.rowData = {};
          this.data();
          // this.selectedUrl = "";
        },

        openModalActive(name, type, id) {
          this.isEditModalActive = true;
          this.filename = name;
          this.filetype = type;
          this.dataId = id;
        },

        closeModalActive() {
          this.preloader = true;
          $("#setting-doc-modal").modal("hide");
          this.isEditModalActive = false;
          setTimeout(() => {
            this.reSetData();
          }, 2000);
        },
    }
}
</script>

<style>
  .btn-table {
  width: 100px;
}
</style>